"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ImageIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.414 4.586c.362.362.586.862.586 1.414v12c0 .552-.224 1.052-.586 1.414A1.994 1.994 0 0121 20H3a1.994 1.994 0 01-1.414-.586A1.994 1.994 0 011 18V6c0-.552.224-1.052.586-1.414A1.994 1.994 0 013 4h18c.552 0 1.052.224 1.414.586zM21 6H3v12h18V6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20 15.923l-1.68-1.147a2.75 2.75 0 00-3.103 0l-2.278 1.557-3.292-3.078a2.75 2.75 0 00-3.756 0L4 15.023V7h16v8.923zM14 13a2 2 0 100-4 2 2 0 000 4z",
    opacity: ".8"
  })));
});
ImageIcon.category = 'Media';
var _default = ImageIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/ImageIcon.js
// module id = 1093
// module chunks = 0